export const formatMileage = (mileage: number, locale: string): string => {
  const formatter = new Intl.NumberFormat(locale, {
    style: "unit",
    unit: "kilometer",
    useGrouping: true,
  });

  return formatter.format(mileage);
};
